import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Spectrophotometer extends React.Component {
  componentWillMount() {
    this.props.createSpectrophotometer({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"Spectrophotometer_"+this.props.id}
          tabIndex={0}
          className={'Spectrophotometer dropTarget'}>
          <p className="label" style={{display: 'none'}}>{this.props.type}</p>
          <Graphics id={this.props.id}/>
        </li>
      </ul>
    );
  }
}

Spectrophotometer.propTypes = {
  createSpectrophotometer: PropTypes.func,
};

Spectrophotometer.defaultProps = {};
